import { getQueryVariable } from "./utils";
export const tenantId = '019005'; //租户Id
export const Authorization = 'c2FiZXI6c2FiZXJfc2VjcmV0'; // 接口请求头
export const appId = process.env.VUE_APP_APPID; // 小程序Appid
export const appKey = process.env.VUE_APP_APPKEY; //应用key
export const clientId = '1440875974823518210'; 
export const wxoffiaccount_auth_url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(location.origin)}&response_type=code&scope=snsapi_userinfo&state=${getQueryVariable('equipmentNumer')}#wechat_redirect`